import React, { useEffect, useState } from 'react';

import { Group } from 'hooks/useGrouping';
import { formatNumber } from 'utils/formatter';
import { usePrevious } from 'hooks/usePrevious';
import TWEEN from '@tweenjs/tween.js';

type GroupingTabProps = {
  group: Group;
  groupTotalAssetAmount: number;
  assetsCount: number;
  isActive: boolean;
  select: () => void;
  groupClass: string;
  tabStyleState: TabStyleState;
};

export const GROUPING_TAB_WIDTH = 150;
export const GROUPIG_TAB_PADDING = 8;
export const GROUPING_TAB_BORDER_WIDTH = 1;

export type TabStyleState =
  | {
      state: 'GROUP_ADD_ANIMATION';
      width: number;
      padding: number;
      opacity: number;
      borderWidth: number;
    }
  | {
      state: 'GROUP_DELETE_ANIMATION';
      width: number;
      padding: number;
      opacity: number;
      borderWidth: number;
    }
  | {
      state: 'GROUP_DELETING';
      width: 0;
      padding: 0;
      opacity: 0;
      allOpacity: number;
      borderWidth: 0;
    }
  | {
      state: 'NORMAL';
      width: typeof GROUPING_TAB_WIDTH;
      padding: typeof GROUPIG_TAB_PADDING;
      opacity: 1;
      borderWidth: 1;
    };

export const normalTabStyle: TabStyleState = {
  state: 'NORMAL',
  borderWidth: 1,
  opacity: 1,
  padding: 8,
  width: 150,
};

const GroupingTab: React.FC<GroupingTabProps> = props => {
  const [amount, setAmount] = useState(props.groupTotalAssetAmount);
  const prevAmount = usePrevious(amount);
  const tabStyle = {
    width: `${Math.round(props.tabStyleState.width)}px`,
    minWidth: `${Math.round(props.tabStyleState.width)}px`,
    paddingLeft: `${Math.round(props.tabStyleState.padding)}px`,
    paddingRight: `${Math.round(props.tabStyleState.padding)}px`,
  };
  const contentOpacity = props.tabStyleState.opacity;

  useEffect(() => {
    if (prevAmount !== undefined) {
      const tween = { amount: prevAmount };
      const t = new TWEEN.Tween(tween)
        .to(
          {
            amount: props.groupTotalAssetAmount,
          },
          1000
        )
        .onUpdate(() => setAmount(tween.amount))
        .start();
      return () => {
        t.stop();
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.groupTotalAssetAmount]);
  return (
    <>
      <li
        className={`grouping-tab-header-item ${props.groupClass} ${
          props.isActive ? 'is-active' : 'cursor-pointer'
        }`}
        style={{
          ...tabStyle,
          // deletingだった場合全体の透明度も落とす
          ...(props.tabStyleState.state === 'GROUP_DELETING'
            ? { opacity: props.tabStyleState.allOpacity }
            : {}),
        }}
        onClick={props.select}>
        <div className="group-label-row" style={{ opacity: contentOpacity }}>
          <div className="icon-folder-outline group-badge"></div>
          <div className="group-label">{props.group.name}</div>
        </div>
        <div className="asset-value-row" style={{ opacity: contentOpacity }}>
          <div className="asset-value">{formatNumber(amount, {})}</div>
          <div className="unit">円</div>
        </div>
        <div className="asset-count-row" style={{ opacity: contentOpacity }}>
          <i className="icon-solid icon-credit-card"></i>
          <div className="asset-count">{`${props.assetsCount}件`}</div>
        </div>
      </li>
    </>
  );
};

export default GroupingTab;
